// Badge Component
// H-F015: Migrado al patrón React 19 — ref como prop directa, sin forwardRef
import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

export interface BadgeProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'secondary' | 'destructive' | 'outline' | 'success';
  ref?: React.Ref<HTMLDivElement>;
}

function Badge({ className, variant = 'default', ref, ...props }: BadgeProps) {
  return (
    <div
      ref={ref}
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors',
        {
          'border-transparent bg-emerald-600 text-white': variant === 'default',
          'border-transparent bg-gray-100 text-gray-900 dark:bg-gray-700 dark:text-gray-200': variant === 'secondary',
          'border-transparent bg-red-600 text-white': variant === 'destructive',
          'text-gray-950 border-gray-300 dark:text-gray-200 dark:border-gray-600': variant === 'outline',
          'border-transparent bg-green-600 text-white': variant === 'success',
        },
        className
      )}
      {...props}
    />
  );
}

export { Badge };
